/* Forever Bella - landing.js: announcement slide, carousel, finder tabs and product gallery swipe.
   The store opens in English for everyone. Visitors can pick Spanish with the language selector. */
(() => {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* Announcement: slide one message at a time */
  $$('[data-announce-slide]').forEach((el) => {
    const slides = $$('.announce__slide', el);
    if (slides.length < 2) return;
    const delay = parseInt(el.dataset.delay, 10) || 4000;
    let i = 0;
    setInterval(() => {
      slides[i].classList.remove('is-active');
      slides[i].classList.add('is-prev');
      const prev = slides[i];
      setTimeout(() => prev.classList.remove('is-prev'), 700);
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, delay);
  });

  /* Product carousel arrows */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-carousel-nav]');
    if (!btn) return;
    const track = $('[data-carousel-track]', btn.closest('[data-carousel]'));
    if (!track) return;
    const step = (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + 20 : 300) * Number(btn.dataset.carouselNav);
    track.scrollBy({ left: step, behavior: 'smooth' });
  });

  /* Finder tabs */
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-tab]');
    if (!tab) return;
    const wrap = tab.closest('[data-tabs]');
    $$('[data-tab]', wrap).forEach((t) => t.setAttribute('aria-selected', t === tab));
    $$('[data-panel]', wrap).forEach((p) => p.classList.toggle('is-active', p.dataset.panel === tab.dataset.tab));
  });

  /* Product gallery: keep the active thumbnail in view in the single-row strip */
  function centerThumb(root) {
    const thumb = $('[data-thumb][aria-current="true"]', root);
    const strip = thumb && thumb.parentElement;
    if (!strip || strip.scrollWidth <= strip.clientWidth) return;
    strip.scrollTo({ left: thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2, behavior: 'smooth' });
  }
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-gallery-nav], [data-thumb]');
    if (!trigger) return;
    const root = trigger.closest('[data-product]');
    setTimeout(() => centerThumb(root), 60);
  });

  /* Product gallery: swipe left or right on the main image */
  let startX = 0;
  let startY = 0;
  document.addEventListener('touchstart', (e) => {
    if (!e.target.closest('.gallery__main')) return;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', (e) => {
    const main = e.target.closest('.gallery__main');
    if (!main || !startX) return;
    const dx = e.changedTouches[0].clientX - startX;
    const dy = e.changedTouches[0].clientY - startY;
    startX = 0;
    if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
    const btn = $('[data-gallery-nav="' + (dx < 0 ? '1' : '-1') + '"]', main);
    if (btn) btn.click();
  }, { passive: true });
})();
